import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type ExperienceIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function ExperienceIcon({
  className,
  pathClassName = "stroke-textPrimary",
  ...props
}: ExperienceIconProps) {
  return (
     <Svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      {...props}
      className={className}
    >
      <Path
        d="M17.709 7.927v1.287a.859.859 0 01-.857.857l-5.139 1.287v-.429a.858.858 0 00-.856-.858H9.144a.856.856 0 00-.857.858v.43L3.148 10.07a.856.856 0 01-.856-.857V7.927a2.146 2.146 0 012.141-2.145h11.135a2.14 2.14 0 012.14 2.145z"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
      <Path
        d="M3.148 10.071l.3 6.074a1.837 1.837 0 001.816 1.647h9.473a1.83 1.83 0 001.815-1.647l.3-6.074"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
      <Path
        d="M10.857 10.071H9.144a.857.857 0 00-.857.858v.858c0 .474.384.858.857.858h1.713a.857.857 0 00.856-.858v-.858a.857.857 0 00-.856-.858zM12.57 5.782V4.066a.858.858 0 00-.857-.858H8.287a.856.856 0 00-.856.858v1.716"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default ExperienceIcon;
